<!--
component: KaihatsuTypeSelector
description: 開発・造成・土石の堆積の種別選択コンポーネント
-->
<template>
  <div class="kaihatsu-type-selector">
    <!-- 通常の開発グループ -->
    <div class="button-group normal">
      <v-btn-toggle :value="normalValue" @change="selectNormal">
        <v-btn active-class="light-blue darken-3 white--text" :value="0">開発</v-btn>
        <v-btn active-class="light-blue darken-3 white--text" :value="1">旧宅造(〜R5)</v-btn>
      </v-btn-toggle>
    </div>
    <!-- 盛土規制法グループとヘルプアイコン -->
    <div class="morido-group">
      <div class="button-group morido">
        <div class="morido-label">盛土規制法</div>
        <v-btn-toggle :value="moridoValue" @change="selectMorido">
          <v-btn active-class="light-blue darken-3 white--text" :value="2">宅地造成</v-btn>
          <v-btn active-class="light-blue darken-3 white--text" :value="3">農地造成</v-btn>
          <v-btn active-class="light-blue darken-3 white--text" :value="4">森林造成</v-btn>
          <v-btn active-class="light-blue darken-3 white--text" :value="5">土石の堆積</v-btn>
        </v-btn-toggle>
      </div>
      <kaihatsu-type-discription-modal />
    </div>
  </div>
</template>

<script>
import KaihatsuTypeDiscriptionModal from './KaihatsuTypeDiscriptionModal.vue'

export default {
  name: 'KaihatsuTypeSelector',
  components: {
    KaihatsuTypeDiscriptionModal
  },
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    normalValue() {
      console.log('normalValue computed:', {
        value: this.value,
        result: [0, 1].includes(this.value) ? this.value : null
      });
      return [0, 1].includes(this.value) ? this.value : null;
    },
    moridoValue() {
      console.log('moridoValue computed:', {
        value: this.value,
        result: [2, 3, 4, 5].includes(this.value) ? this.value : null
      });
      return [2, 3, 4, 5].includes(this.value) ? this.value : null;
    }
  },
  methods: {
    isMoridoValue(val) {
      return [2, 3, 4, 5].includes(val);
    },
    getTargetType(val) {
      const typeMap = [
        0, 1, 2, 3, 4, 5
      ];
      return typeMap[val] || 0;
    },
    selectNormal(val) {
      console.log('selectNormal called with:', val);
      if (val !== null) {
        this.$nextTick(() => {
          this.$emit('input', val);
          this.$emit('update:selected-type', val);
        });
      }
    },
    selectMorido(val) {
      console.log('selectMorido called with:', val);
      if (val !== null) {
        this.$nextTick(() => {
          this.$emit('input', val);
          this.$emit('update:selected-type', val);
        });
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        console.log('value changed:', newVal);
        this.lastSelectedValue = newVal;
      }
    }
  },
  data() {
    return {
      lastSelectedValue: null
    }
  }
}
</script>

<style lang="scss" scoped>
.kaihatsu-type-selector {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  @media screen and (max-width: 1330px) {
    flex-direction: column;
    align-items: flex-start;
  }

  .morido-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex: 1;
  }

  .button-group {
    display: flex;
    flex-direction: row;
    align-items: center;

    &.morido {
      position: relative;
      background-color: #afdfdf;
      border-radius: 4px;
      flex: 1;
      padding: 12px 16px;

      @media screen and (max-width: 1330px) {
        flex: none;
      }

      .morido-label {
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        color: #666;
        font-size: 0.8em;
        font-weight: bold;
        white-space: nowrap;
      }
    }

    &.normal {
      padding: 12px 0;
    }
  }

  :deep(.v-btn-toggle) {
    display: flex;
    flex-direction: row;
  }

  :deep(.v-btn) {
    min-width: fit-content;
    height: 36px;
    font-size: 0.9em;
  }

  .help-icon {
    flex-shrink: 0;
    margin-left: 4px;
  }
}

:deep(.tooltip-content) {
  display: block;
  white-space: normal;
  max-width: 600px;
  font-size: 0.9em;
  line-height: 1.5;

  .tooltip-section {
    padding: 8px 0;
    
    > div {
      margin: 4px 0;
    }
  }

  .tooltip-divider {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 4px 0;
  }
}
</style> 